import { Text } from "@/atoms"

import type { CallbackParams } from "@/molecules/OSStep"

export const MessageVmTab = ({ isWindows, t }: CallbackParams) => {
  const tKey = isWindows ? "windows" : "vm"

  return (
    <span>
      <Text>
        {t(`deployments.${tKey}.alert.text1`)}
        <br />
        {t(`deployments.${tKey}.alert.text2`)}
      </Text>
      <br />
      <b>{t(`deployments.${tKey}.alert.note`)}</b>
    </span>
  )
}
